import * as React from "react"
import { usePage } from "@inertiajs/react"
import { AdminSidebar } from "@/components/AdminSidebar"
import { cn } from "@/lib/utils"
import type { PageProps } from "@/types/inertia"

// Wraps a public marketing page so a signed-in admin keeps the navigation rail
// while browsing the site, and everyone else gets the page exactly as designed.
//
// AdminSidebar renders nothing at all for guests (and /admin is gated
// server-side by Admin::BaseController regardless), so this adds no markup and
// no offset to a visitor's page — the padding is applied only when the rail is
// actually there to be cleared.
//
// The offset is lg-only on purpose: below that the rail is an off-canvas drawer
// that overlays rather than displaces, so the page keeps its full width and
// SiteHeader stacks under the drawer's opener bar instead.
export function PublicShell({ children }: { children: React.ReactNode }) {
  const isAdmin = usePage<PageProps>().props.current_user?.admin ?? false

  return (
    <>
      <AdminSidebar />
      <div className={cn(isAdmin && "lg:pl-56")}>{children}</div>
    </>
  )
}
